import React, { useEffect, useState } from "react";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { responsive } from "../../utils/style";
import { ExpandableTab } from "../../components/Quiz/ExpandableTab";
import { QuizCard } from "../../components/Quiz/QuizCard";
import useAuth from "../../utils/useAuth";
import { ExcellentCard } from "../../components/Quiz/ExcellentCard";
import QuizContainer from "../../components/Quiz/QuizContainer";
import { QuizHeader } from "../../components/Quiz/QuizHeader";
import { useNavigate } from "react-router-dom";
import api from "../../utils/api";
import { getSummaryScore } from "../../utils/toPercent";

export const Quiz = () => {
  const { username, isStaff } = useAuth();
  const navigate = useNavigate();
  const [quizCategories, setQuizCategories] = useState([]);

  const [summaryScore, setSummaryScore] = useState(0);

  const isExcellent = () => {
    if (!quizCategories.length) return false;
    for (let i = 0; i < quizCategories.length; ++i) {
      if (quizCategories[i].score < 8) return false;
    }

    return true;
  };

  useEffect(() => {
    setSummaryScore(getSummaryScore(quizCategories.map((q) => q.score)));
  }, [quizCategories]);

  useEffect(() => {
    api
      .get("/quiz/getQuizHistories")
      .then((res) => {
        if (res.status === 200) setQuizCategories(res?.data?.quizHistories);
      })
      .catch((err) => alert("ไม่สามารถดึงข้อมูลรายการแบบทดสอบได้"));
  }, []);

  const haveDoQuiz = () => {
    if (!quizCategories.length) return false;
    for (let i = 0; i < quizCategories.length; ++i) {
      if (quizCategories[i].totalFinish > 0) return true;
    }
    return false;
  };

  const isFinishAll = () => {
    if (!quizCategories.length) return false;
    for (let i = 0; i < quizCategories.length; ++i) {
      if (quizCategories[i].totalFinish < 2) return false;
    }
    return true;
  };

  return (
    <QuizContainer>
      <center>
        <QuizHeader>
          {isStaff
            ? `เฉลยแบบทดสอบ
            ชุดความรู้เณรกล้า โภชนาดี`
            : "แบบทดสอบชุดความรู้เณรกล้า โภชนาดี"}
        </QuizHeader>
        {isStaff && (
          <SeeCorrectAnswersButton
            onClick={(e) => navigate("/quiz/rightAnswers")}
          >
            เฉลยแบบทดสอบออนไลน์
          </SeeCorrectAnswersButton>
        )}
        {username && !isStaff && (
          <>
            <SummaryButton
              disabled={!haveDoQuiz()}
              onClick={(e) => navigate("/quiz/summaryScore")}
            >
              สรุปคะแนน
            </SummaryButton>
            {haveDoQuiz() && (
              <SummaryScoreContainer>
                <div style={{ display: "flex", alignItems: "center" }}>
                  คะแนนสะสม&nbsp;&nbsp;&nbsp;
                  <span>{summaryScore}</span>
                </div>
                <div>
                  <span>
                    {summaryScore}
                    &nbsp;&nbsp;%
                  </span>
                </div>
              </SummaryScoreContainer>
            )}

            {isExcellent() && !isStaff && (
              <ExcellentCard summaryScorePercent={summaryScore} />
            )}
          </>
        )}
        {!isFinishAll() && !isStaff && (
          <SubHeader isMarginTop={username && isFinishAll()}>
            การทำแบบทดสอบแต่ละเล่ม ทำได้ 2 ครั้งโดยระบบจะเก็บ
            ข้อมูลครั้งที่ได้คะแนนสูงกว่า
          </SubHeader>
        )}
      </center>
      <ExpandableTab label={"กติกาการทำแบบทดสอบออนไลน์"}>
        <strong>
          1. การทำแบบทดสอบแต่ละเล่ม ทำได้ 2
          ครั้งโดยระบบจะเก็บข้อมูลครั้งที่ได้คะแนนสูงกว่า
        </strong>
        <br />
        2. ข้อสอบแต่ละเล่ม มี 10 ข้อ คะแนน <strong>ดีมาก</strong> = ตอบถูก 8 ข้อ
        ขึ้นไป คือ ไม่ต่ำกว่า 80%
        <br />
        3. ข้อสอบทั้งหมด 10 เล่ม รวม 100 ข้อ คะแนน <strong>ดีมาก</strong> =
        ตอบถูก 80 ข้อ ขึ้นไป คือ ไม่ต่ำกว่า 80%
        <br />
        4. ถ้าทำข้อสอบทั้งหมด 100 ข้อ คะแนน <strong>ดีมาก</strong> = ตอบถูก 80
        ข้อ ขึ้นไป คือ ไม่ต่ำกว่า 80% และ ทุกเล่ม = ตอบถูก 8 ข้อ ขึ้นไป คือ
        ไม่ต่ำกว่า 80% จะได้รับถ้วยเณรกล้า
        โภชนาดีทางออนไลน์ในใบแสดงผลในสรุปคะแนน
      </ExpandableTab>
      <QuizCardContainer>
        {quizCategories.map((q) => (
          <QuizCard {...q} canDo={!isStaff} clickableCard={isStaff} />
        ))}
      </QuizCardContainer>
    </QuizContainer>
  );
};

const SummaryButton = styled.button`
  padding: 14px 64px;
  border: 1px solid ${(props) => (props.disabled ? "#d0d5dd" : "#16AF7B")};
  border-radius: 100px;
  background: ${(props) => (props.disabled ? "#f7f8f9" : "#B5F6DF")};
  margin-top: 16px;
  margin-bottom: 32px;
  cursor: pointer;
  color: ${(props) => (props.disabled ? "#d0d5dd" : "#16AF7B")};
  font-weight: 600;
  font-size: 20px;
`;

const QuizCardContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  gap: 16px;
  margin-top: 16px;

  ${responsive.mobile(css`
    grid-template-columns: auto;
  `)}
`;

const SummaryScoreContainer = styled.div`
  display: flex;
  color: #fb633d;
  font-weight: 600;
  font-size: 18px;
  justify-content: space-between;

  span {
    font-size: 28px;
  }
`;

const SubHeader = styled.p`
  font-familiy: "Bai Jamjuree";
  color: #ff6a40;
  font-weight: 600;
  font-size: 14px;
  margin-top: ${(props) => (props.isMarginTop ? "16px" : "0px")};
  margin-bottom: 16px;
`;

const SeeCorrectAnswersButton = styled.button`
  padding: 12px 32px 12px 32px;
  width: 100%;
  max-width: 360px;
  margin-bottom: 32px;
  background: #16af7b;
  color: white;
  border: 0px;
  border-radius: 100px;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
`;
